var _path, _circle, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgClient = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 90,
    viewBox: "0 0 84 90",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4575 42.8387C23.4575 32.3991 31.9204 23.9362 42.36 23.9362V23.9362C51.3973 23.9362 58.7234 31.2623 58.7234 40.2996V44.6808H23.4575V42.8387Z",
    fill: "#E45E66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.7287,
    cy: 10.133,
    r: 10.133,
    fill: "#E45E66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 53.7766V59.0873H11.3278C12.0823 61.1237 13.0295 63.0666 14.1473 64.8939L5.74468 71.4747L16.371 85.0427L26.7842 76.8873C29.0892 78.1361 31.5575 79.1218 34.1489 79.8043V90H51.383V79.7619C54.0172 79.0541 56.5229 78.0325 58.8576 76.7397L65.3604 85.0427L79.8079 73.7276L71.9354 63.6757C72.7489 62.2103 73.4554 60.6773 74.0445 59.0873H83.7651V53.7766H0Z",
    fill: "#D14547"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7766 53.7766C23.8196 63.7427 31.9119 71.8085 41.8881 71.8085C51.8643 71.8085 59.9567 63.7427 59.9997 53.7766H23.7766Z",
    fill: "#E67070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 49.2958C0 38.9034 8.42467 30.4788 18.817 30.4788V30.4788C27.8134 30.4788 35.1064 37.7718 35.1064 46.7681V51.2234H0V49.2958Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 49.2958C0 38.9034 8.42467 30.4788 18.817 30.4788V30.4788C27.8134 30.4788 35.1064 37.7718 35.1064 46.7681V51.2234H0V49.2958Z",
    fill: "#FD8087"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6702 49.2958C48.6702 38.9034 57.0949 30.4788 67.4873 30.4788V30.4788C76.4836 30.4788 83.7766 37.7718 83.7766 46.7681V51.2234H48.6702V49.2958Z",
    fill: "#FFADB2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4734,
    cy: 16.8351,
    r: 10.133,
    fill: "#FD8087"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.1436,
    cy: 16.8351,
    r: 10.133,
    fill: "#FFADB2"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClient, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/client.3836e3e7.svg";
export { ForwardRef as ReactComponent };